import React, { Component } from 'react';
import { FieldArray, reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import * as $ from 'jquery';

import GlassForm from './eyeglass/GlassForm';
import LabOrderButton from './eyeglass/labOrder/LabOrderButton';
import LabOrderModal from './eyeglass/labOrder/LabOrderModal';
import ImportWrapper from './import/ImportWrapper';
import UseWarrantyModal from './warranty/UseWarrantyModal';
import { orderCloseModal, orderLoad } from '../../../../redux/actions/order/orderActions';
import { orderPromotionRemove } from '../../../../redux/actions/order/orderPromotionActions';
import DuplicateLensOrGlassButton from '../../buttons/DuplicateLensOrGlassButton';
import PromotionBanner from './promotions/PromotionBanner';


class RenderEyeglasses extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPromoRemoved: false,
      isUseWarrantyModalOpen: false,
      useWarrantyId: null,
    };
  }

  reloadOrder = () => {
    const { order, pprops } = this.props;
    if (order?.id) pprops.dispatch(orderLoad(order.id, { include: '*' }));
  }

  openUseWarranty = (warrantyId = null) => {
    this.setState({
      isUseWarrantyModalOpen: true,
      useWarrantyId: warrantyId || null,
    });
  }

  closeUseWarranty = () => {
    this.setState({ isUseWarrantyModalOpen: false, useWarrantyId: null });
  }

  componentDidUpdate(prevProps) {
    const currentPromo = this.props.appliedPromotion || this.props.pprops?.appliedPromotion;
    const prevPromo = prevProps.appliedPromotion || prevProps.pprops?.appliedPromotion;
    if (currentPromo && !prevPromo && this.state.isPromoRemoved) {
      this.setState({ isPromoRemoved: false });
    }
  }

  importFinalGlass(member, index, data) {
    const { pprops } = this.props
    pprops.dispatch(change('orderEyeglassForm', `${member}[od_glass_details][sphere]`, data.od_sphere))
    pprops.dispatch(change('orderEyeglassForm', `${member}[od_glass_details][cylinder]`, data.od_cylinder))
    pprops.dispatch(change('orderEyeglassForm', `${member}[od_glass_details][axis]`, data.od_axis))
    pprops.dispatch(change('orderEyeglassForm', `${member}[od_glass_details][add]`, data.od_add))
    pprops.dispatch(change('orderEyeglassForm', `${member}[od_glass_details][prism]`, data.od_prism))
    pprops.dispatch(change('orderEyeglassForm', `${member}[os_glass_details][sphere]`, data.os_sphere))
    pprops.dispatch(change('orderEyeglassForm', `${member}[os_glass_details][cylinder]`, data.os_cylinder))
    pprops.dispatch(change('orderEyeglassForm', `${member}[os_glass_details][axis]`, data.os_axis))
    pprops.dispatch(change('orderEyeglassForm', `${member}[os_glass_details][add]`, data.os_add))
    pprops.dispatch(change('orderEyeglassForm', `${member}[os_glass_details][prism]`, data.od_prism))
    $(`#examFinalGlass-Modal${index}`).modal('hide')
  }

  handleRemovePromotion = async () => {
    const { pprops, order } = this.props;
    this.setState({ isPromoRemoved: true });
    pprops.dispatch(change('orderEyeglassForm', 'applied_promotion', null));
    pprops.dispatch(change('orderEyeglassForm', 'eyeglasses_attributes[0][overall_cash_discount]', 0));
    pprops.dispatch(change('orderEyeglassForm', 'eyeglasses_attributes[0][overall_percentage_discount]', 0));
    pprops.dispatch(change('orderEyeglassForm', 'eyeglasses_attributes[0][frame_details][promotion]', 'None'));
    if (order && order.orders_promotion && order.orders_promotion.id) {
      const payload = {
        order: {
          orders_promotion_attributes: {
            id: order.orders_promotion.id,
            _destroy: true,
            settings_promotion_id: null,
          },
        },
      };
      await pprops.dispatch(orderPromotionRemove(order.id, payload, { include: '*' }));
      await pprops.dispatch(orderLoad(order.id, { include: '*' }));
    } else {
      pprops.dispatch(change('orderEyeglassForm', 'orders_promotion_attributes', null));
      if (order && order.id) {
        await pprops.dispatch(orderLoad(order.id, { include: '*' }));
      }
    }
  };

  render() {
    const { fields, pprops, order, onRemoteSubmit, currentUser, appliedPromotion } = this.props;
    const currentPromo = !this.state.isPromoRemoved && (appliedPromotion || pprops.appliedPromotion);
    return (
      <div className="row">
        {currentPromo && (
          <div className="col-12 my-3">
            <PromotionBanner
              promotion={currentPromo}
              onRemove={this.handleRemovePromotion}
            />
          </div>
        )}
        <div className="col-12 mb-7">
          <div className="d-flex justify-content-between align-items-center mt-6">
            <h5>Eyeglass Order</h5>
            <div className="d-flex align-items-center">
              {order.warranty_attributes?.length > 0 && (
                <button
                  type="button"
                  className="btn btn-outline-primary mr-3 d-inline-flex align-items-center"
                  onClick={() => this.openUseWarranty()}
                >
                  <i className="las la-shield-alt mr-2 font-size-18" />
                  Apply Warranty
                </button>
              )}
              <div className={`d-flex align-items-center ${order.status === 'finalized' && 'disabled'}`}>
                <ImportWrapper order={order} importName="eyeglass" addBtnLabel="Add New From Existing Prescription" importNameTitle="Eyeglass Prescription" />
                <button type="button" className="btn btn-primary ml-5" onClick={() => { fields.push({ current_user_id: currentUser?.id }); setTimeout(() => pprops.submit(), 500) }}>
                  <i className='la la-plus mr-2 font-size-16'></i>
                  Add New
                </button>
              </div>
            </div>
          </div>
        </div>

        <UseWarrantyModal
          isOpen={this.state.isUseWarrantyModalOpen}
          onClose={this.closeUseWarranty}
          onSuccess={this.reloadOrder}
          order={order}
          initialWarrantyId={this.state.useWarrantyId}
        />

        {fields.map((member, index, members) => {
          const eyeglass = members.get(index)
          const warranty = eyeglass?.warranty_attributes
          return (
          <div key={index} className="col-12 mb-7">
            <div className="bg-white shadow-sm rounded">
              <div className="row mx-0">
                <div className="col-12 p-5 border-bottom border-bottom-2 border-light">
                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className={`${order.status === 'finalized' && 'disabled'}`}>
                      Eyeglass Order #{index + 1}
                      {eyeglass.sub_order_id && <span className="ml-3">| Sub ID: {eyeglass.sub_order_id}</span>}
                    </h5>
                    <div className="d-flex align-items-center">
                      {warranty?.id && (
                        <button
                          type="button"
                          className="btn btn-outline-primary mx-3 d-inline-flex align-items-center"
                          onClick={() => this.openUseWarranty(warranty.id)}
                        >
                          <i className="las la-shield-alt mr-2 font-size-18" />
                          <span>Apply Warranty</span>
                        </button>
                      )}
                      <div className={`${order.status === 'finalized' && 'disabled'}`}>
                        <DuplicateLensOrGlassButton orderId={order.id} lensOrGlassName='eyeglass' id={eyeglass?.id}>
                          <button className={`btn btn-outline-primary mx-3`} aria-disabled="true">Duplicate</button>
                        </DuplicateLensOrGlassButton>
                        {
                          members.get(index).is_on_hold ?
                            <button type="button" className="btn btn-warning mx-3"
                              onClick={() => { pprops.dispatch(change('orderEyeglassForm', `${member}[is_on_hold]`, false)); setTimeout(() => pprops.submit(), 500) }}
                            >
                              Unhold Order
                            </button>
                            :
                            <button type="button" className="btn btn-outline-primary mx-3"
                              onClick={() => { pprops.dispatch(change('orderEyeglassForm', `${member}[is_on_hold]`, true)); setTimeout(() => pprops.submit(), 500) }}
                            >
                              Hold Order
                            </button>
                        }
                        {order.exam_examination_id &&
                          <button onClick={() => $(`#examFinalGlass-Modal${index}`).modal()} type="button" className="btn btn-outline-primary mx-3" >
                            Final Rx
                          </button>
                        }
                      </div>
                      <LabOrderButton resourceId={eyeglass.id} labOrderId={eyeglass.lab_order_id}>
                        <button type="button" className="btn btn-outline-primary mx-3" onClick={()=>onRemoteSubmit('orderEyeglassForm')}>
                          Lab Order
                        </button>
                      </LabOrderButton>
                      <button type="button" className={`${order.status === 'finalized' && 'disabled'} btn btn-outline-danger ml-3`}
                        onClick={() => { pprops.dispatch(change('orderEyeglassForm', `${member}[_destroy]`, true)); setTimeout(() => pprops.submit(), 500) }}>
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
                <div className={`${order.status === 'finalized' && 'disabled'}`}>
                  {eyeglass.id &&
                    <GlassForm
                      key={`glass-id${eyeglass.id}`}
                      {...this.props}
                      currentEyeglass={eyeglass}
                      member={member}
                    />
                  }
                </div>
              </div>
            </div>
            <LabOrderModal resourceId={eyeglass.id} resourceType="Orders::Eyeglass" />
            {this.renderExamLensModal(member, index)}
          </div>
          )
        })}
      </div>
    );
  }

  renderExamLensModal(member, index) {
    const { exam } = this.props
    return (
      <div className="inner-modal">
        <div className="modal fade" id={`examFinalGlass-Modal${index}`} tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content border-0 rounded shadow-lg">
              <div className="modal-header border-bottom border-bottom-2 border-light">
                <h5>Finalized Glass Prescriptions</h5>
                <button type="button" className="btn btn-outline-primary" onClick={() => $(`#examFinalGlass-Modal${index}`).modal('hide')}>
                  Close
                </button>
              </div>
              <div className="modal-body px-0 py-5">
                {
                  exam.id && exam.finalized_glasses_attributes.map((finalizedGlass, index) =>
                    <div className="overview-table mb-7">
                      <table className="table table-hover shadow-none">
                        <thead>
                          <tr className="text-dark border-bottom border-bottom-2 border-light bg-light">
                            <th scope="col">{index + 1}</th>
                            <th scope="col" colSpan="5">Issue Date: {exam.issue_date}</th>
                            <th scope="col">
                              <button className="btn btn-primary px-3 py-2" onClick={() => this.importFinalGlass(member, index, finalizedGlass)}>
                                Import
                              </button>
                            </th>
                          </tr>
                          <tr className="text-dark border-bottom border-bottom-2 border-white bg-light">
                            <th scope="col"></th>
                            <th scope="col">Eye</th>
                            <th scope="col">SPH</th>
                            <th scope="col">CYL</th>
                            <th scope="col">Axis</th>
                            <th scope="col">Add</th>
                            <th scope="col">Prism</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="text-dark border-bottom border-bottom-2 border-white bg-light">
                            <td></td>
                            <td>OD</td>
                            <td>{finalizedGlass.od_sphere}</td>
                            <td>{finalizedGlass.od_cylinder}</td>
                            <td>{finalizedGlass.od_axis}</td>
                            <td>{finalizedGlass.od_add}</td>
                            <td>{finalizedGlass.od_prism}</td>
                          </tr>
                          <tr className="text-dark border-bottom border-bottom-2 border-white bg-light">
                            <td></td>
                            <td>OS</td>
                            <td>{finalizedGlass.os_sphere}</td>
                            <td>{finalizedGlass.os_cylinder}</td>
                            <td>{finalizedGlass.os_axis}</td>
                            <td>{finalizedGlass.os_add}</td>
                            <td>{finalizedGlass.os_prism}</td>
                          </tr>
                          <tr className="text-dark border-bottom border-bottom-2 border-white bg-light">
                            <td></td>
                            <td className="font-weight-bold">Recommendations</td>
                            <td colSpan="5">
                              {
                                finalizedGlass.recommendations && Object.keys(finalizedGlass.recommendations).join(", ")
                              }
                            </td>
                          </tr>
                          <tr className="text-dark border-bottom border-bottom-2 border-white bg-light">
                            <td></td>
                            <td className="font-weight-bold">Comments</td>
                            <td colSpan="5">
                              {finalizedGlass.notes}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


class EyeglassForm extends Component {
  componentWillUnmount() {
    this.props.dispatch(orderCloseModal(false))
  }

  render() {
    const { handleSubmit, order, exam, onSubmit, onRemoteSubmit, appliedPromotion } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <FieldArray name="eyeglasses_attributes"
          props={{
            order: order,
            exam: exam,
            onSubmit: onSubmit,
            onRemoteSubmit: onRemoteSubmit,
            currentUser: this.props.currentUser,
            appliedPromotion: appliedPromotion,
            pprops: this.props,
          }}
          component={RenderEyeglasses} />
      </form>
    )
  }
}


EyeglassForm = reduxForm({
  form: 'orderEyeglassForm',
  enableReinitialize: true,
  onChange: (values, dispatch, props) => {
    if (props.dirty) {
      dispatch(orderCloseModal(true))
    }
  }
})(EyeglassForm)

const selector = formValueSelector('orderEyeglassForm')

EyeglassForm = connect(state => {
  const { order: { order }, exam: { exam }, auth } = state
  const currentEyeglassAttributes = selector(state, 'eyeglasses_attributes')
  const appliedPromotion = selector(state, 'applied_promotion')
  const eyeglassAttrs = currentEyeglassAttributes || order.eyeglasses_attributes || []
  const framePromoName = eyeglassAttrs[0]?.frame_details?.promotion
  const resolvedPromotion =
    appliedPromotion !== undefined
      ? appliedPromotion
      : (order.orders_promotion
        ? {
            name: order.orders_promotion.name || order.orders_promotion.code || 'Promotion',
            code: order.orders_promotion.code,
            savings: order.orders_promotion.savings || 0,
          }
        : framePromoName && framePromoName !== 'None'
        ? {
            name: framePromoName,
            code: '',
            savings: parseFloat(eyeglassAttrs[0]?.overall_cash_discount || 0) || 0,
          }
        : null)

  return {
    exam: exam,
    order: order,
    currentUser: auth.user,
    currentEyeglassAttributes,
    appliedPromotion: resolvedPromotion,
    initialValues: {
      id: order.id,
      eyeglasses_attributes: order.eyeglasses_attributes,
      applied_promotion: resolvedPromotion
    }
  }
})(EyeglassForm)

export default EyeglassForm;
